import React, { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from 'prop-types';
import { useTheme } from "@mui/material/styles";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const theme = useTheme(); 
  const isDark = theme.palette.mode === 'dark'; 

  // Set default autoClose to 2000ms (2 seconds)
  const TOAST_CLOSE_TIMER = 5000;

  const defaultOptions = { autoClose: TOAST_CLOSE_TIMER };

  const notify = {
    success: (msg, options={}) => toast.success(msg, { ...defaultOptions, ...options }),
    error:   (msg, options={}) => toast.error(msg,   { ...defaultOptions, ...options }),
    info:    (msg, options={}) => toast.info(msg,    { ...defaultOptions, ...options }),
    warn:    (msg, options={}) => toast.warn(msg,    { ...defaultOptions, ...options }),
  };

  return (
    <ToastContext.Provider value={notify}>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={TOAST_CLOSE_TIMER}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        pauseOnFocusLoss
        limit={3}
        theme={isDark ? "dark" : "light"} 
      />
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useToast() {
  return useContext(ToastContext);
}